<template>
    <BaseDialog
        :showDialog="!!dialog.show"
        maxDialogWidth="520"
        headline="lang_PUBLISHING_USAGE_CAPTION_REVIEW_BULK_TITLE"
        :close="close"
        :alvqa="alvqa"
    >
        <template v-slot:dialogText>
            <v-container fluid v-if="dialog.show">
                <v-row>
                    <v-col :alvqa="alvqa + '-text'">
                        {{ $t('lang_PUBLISHING_USAGE_CAPTION_REVIEW_BULK_QUESTION', {
                            count: $n(dialog.count || 0),
                            decision: $t(decisionText)
                        }) }}
                    </v-col>
                </v-row>
                <v-row v-if="dialog.scope === 'filter'">
                    <v-col class="caption subtitleGray--text pt-0">{{ $t('lang_PUBLISHING_USAGE_CAPTION_REVIEW_BULK_FILTERED_HINT') }}</v-col>
                </v-row>
                <v-row v-if="dialog.error">
                    <v-col><v-alert type="error" dense text class="mb-0">{{ dialog.error }}</v-alert></v-col>
                </v-row>
            </v-container>
        </template>
        <template v-slot:dialogActions>
            <v-spacer />
            <BaseButton label="lang_GENERAL_BUTTON_CANCEL" color="buttonCancel" class="mr-2" :alvqa="alvqa + '-button-cancel'" @click="close" />
            <BaseButton label="lang_GENERAL_CONFIRM" :loading="!!dialog.running" :alvqa="alvqa + '-button-confirm'" @click="$store.dispatch('runUsageReviewBulk')" />
        </template>
    </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/_base/BaseDialog'
import BaseButton from '@/components/_buttons/BaseButton'
import { DECISIONS, optionText } from '../../usageOptions'

export default {
    name: 'BulkReviewDialog',
    components: { BaseDialog, BaseButton },
    data() {
        return { alvqa: 'publishing-usage-review-bulk-dialog' }
    },
    computed: {
        dialog() { return this.$store.getters.getUsageReviewBulkDialog },
        decisionText() { return optionText(DECISIONS, this.dialog.decision) }
    },
    methods: {
        close() {
            this.$store.commit('setUsageReviewBulkDialog', { show: false })
            this.$store.commit('setSelectedUsageReviewAction', [])
        }
    }
}
</script>
